import * as React from 'react';
var SvgSandwichBoard = () => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.75 4a.75.75 0 0 0-.723.55l-4 14.5a.75.75 0 1 0 1.446.4L6.425 16h3.887l.704 3.402a.75.75 0 0 0 .734.598h7.5a.75.75 0 0 0 .734-.902l-3-14.5A.75.75 0 0 0 16.25 4h-7.5ZM10 14.5 8.646 7.948 6.838 14.5h3.163Zm2.36 4-2.69-13h5.968l2.69 13H12.36Z",
  fill: "currentColor"
}));
export default SvgSandwichBoard;